export const SERVICE_LEVELS = [
  'Same Day',
  'Next Day',
  'Economy',
  '3 Day',
  '5 Day',
] as const;

export type ServiceLevel = (typeof SERVICE_LEVELS)[number];

export const DEFAULT_SERVICE_LEVEL: ServiceLevel = 'Next Day';

export function isServiceLevel(
  value: string | undefined | null
): value is ServiceLevel {
  return !!value && (SERVICE_LEVELS as readonly string[]).includes(value);
}

export const OFF_ROUTE_DISTANCE_UNIT = 'miles';

export const MAXIMUM_FUEL_SURCHARGE_PERCENTAGE = 100;
